import {
  START_LOADING,
  STOP_LOADING,
  SHOW_SPINNER,
  HIDE_SPINNER,
  ADD_BEHAVIORS,
  ADD_PRISMIC_CONTENT,
  LOAD_AVATAR,
  REMOVE_BEHAVIOR,
  REMOVE_BEHAVIORS,
  SET_IS_MOBILE
} from './cms-actions';

export const startLoading = () => dispatch => {
  dispatch({ type: START_LOADING });
};

export const stopLoading = () => dispatch => {
  dispatch({ type: STOP_LOADING });
};

export const showSpinner = () => dispatch => {
  dispatch({ type: SHOW_SPINNER });
};

export const hideSpinner = () => dispatch => {
  dispatch({ type: HIDE_SPINNER });
};

export const addBehaviors = (stepId: string, behaviors: any) => dispatch => {
  dispatch({
    type: ADD_BEHAVIORS,
    payload: { stepId, behaviors },
  });
};

export const addPrismicContent = (stepId: string, prismic: any) => dispatch => {
  dispatch({
    type: ADD_PRISMIC_CONTENT,
    payload: { stepId, prismic },
  });
};

export const removeBehavior = (stepId: string, behaviorKey: string) => async dispatch => {
  await dispatch({
    type: REMOVE_BEHAVIOR,
    payload: { stepId, behaviorKey },
  });
};

export const removeBehaviors = (stepId: string) => async dispatch => {
  await dispatch({
    type: REMOVE_BEHAVIORS,
    payload: { stepId },
  });
};

export const setIsMobile = (data) => dispatch => {
  dispatch({
    type: SET_IS_MOBILE,
    payload: data,
  });
};

export const loadAvatar = (avatar) => dispatch => {
  dispatch({
    type: LOAD_AVATAR,
    payload: avatar,
  });
};
